


























import { Component, Prop, Mixins } from 'vue-property-decorator'

import AppRatingBar from '@/components/AppRatingBar.vue'
import AppRouterLink from '@/components/AppRouterLink.vue'
import ItemReviewList from '@/components/ItemReviewList.vue'
import { CURRENT_USER } from '@/gql/auth'
import { SHOW_LOGIN_MODAL } from '@/gql/misc'
import { REVIEWABLE_ORDER_ITEM_IDS } from '@/gql/user'
import { Common } from '@/mixins'

@Component({
  components: {
    AppRatingBar,
    AppRouterLink,
    ItemReviewList
  },
  apollo: {
    currentUser: {
      query: CURRENT_USER
    },
    reviewableOrderItems: {
      query: REVIEWABLE_ORDER_ITEM_IDS,
      variables () { return { itemId: this.itemId } },
      skip () { return !this.currentUser }
    }
  }
})
export default class extends Mixins(Common) {
  @Prop(String) readonly itemId!: string
  @Prop(Number) readonly itemReviewCount!: number
  @Prop(Number) readonly itemReviewRate!: number

  currentUser: { id: string } | null = null
  reviewableOrderItems = []

  async onClickWrite () {
    if (!this.currentUser) {
      await this.$apollo.mutate({ mutation: SHOW_LOGIN_MODAL })
    } else {
      alert('리뷰는 상품 구매 후 작성하실 수 있습니다.')
    }
  }
}
